import React from 'react'
import PropTypes from 'prop-types'
import { useIntl, defineMessages } from 'react-intl'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import AppPropTypes from '../../shared/appPropTypes'
import { mikePalette } from '@mike/mike-shared-frontend/mike-shared-styles/mikeSharedTheme'
import { ReactComponent as Folder } from '@mike/mike-shared-frontend/media/icons/Folder'
import { css } from '@emotion/css'

const localMessages = defineMessages({
  createSubprojectButton: {
    id: 'createProjectForm.createSubprojectButton'
  }
})

const StyledButton = styled(Button)({
  padding: 0,
  paddingRight: 12,
  width: 150,
  border: '2px solid ' + mikePalette.secondary.main,
  color: mikePalette.secondary.main,
  '&[disabled]': {
    color: mikePalette.secondary.light,
    opacity: 0.5,
    cursor: 'not-allowed'
  }
})

const iconStyle = css`
  path {
    fill: ${mikePalette.secondary.main};
  }
`

const CreateSubprojectButton = ({ size = undefined, ...buttonProps }) => {
  const intl = useIntl()
  return (
    <StyledButton size={size} {...buttonProps}>
      <Folder className={iconStyle} />
      {intl.formatMessage(localMessages.createSubprojectButton)}
    </StyledButton>
  )
}
CreateSubprojectButton.propTypes = {
  size: AppPropTypes.mduiSizes
}

export default CreateSubprojectButton
